import './styles/App.css';
import HomeContent from "./pages/HomeContent";
import Guide from "./pages/Guide";
import ContentCoordinateForm from "./pages/ContentCoordinateForm";
import ContentDemand from "./pages/ContentDemand";
import Layout from "./pages/Layout";
import Contact from "./pages/Contact";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FormNewAnalysis from './pages/new-analysis/FormNewAnalysis';
import Simulation from './pages/Simulation';
import ModifyOrder from './pages/ModifyOrder';
import MaterialOrder from './pages/MaterialOrder';
import Login from './pages/login/Login';
import Inscription from './pages/login/Inscription';
import PageNotFound from './pages/errors/PageNotFound';
import ServerError from './pages/errors/ServerError';
import Forbidden from './pages/errors/Forbidden';
import PaymentError from './pages/errors/PaymentError';
import PaymentSuccess from './pages/errors/PaymentSuccess';
import Payment from './pages/Payment';
import { AuthRoute, PrivateRoute } from './utilities/auth';

export default function App() {

  return (
    <div className="w-screen h-screen bg-[#f5f5f5] flex items-center justify-center">
      <BrowserRouter>
        <Routes>
          <Route index element={<AuthRoute> <Login /> </AuthRoute>} />
          <Route path="inscription" element={<AuthRoute> <Inscription /> </AuthRoute>} />
          <Route path="main" element={<PrivateRoute> <Layout /> </PrivateRoute>}>
            <Route index element={<PrivateRoute> <HomeContent /> </PrivateRoute>} />
            <Route path="coordinate_form" element={<PrivateRoute> <ContentCoordinateForm /> </PrivateRoute>} />
            <Route path="demand" element={<PrivateRoute> <ContentDemand /> </PrivateRoute>} />
            <Route path="contact" element={<PrivateRoute> <Contact /> </PrivateRoute>} />
            <Route path="material_order" element={<PrivateRoute> <MaterialOrder /> </PrivateRoute>} />
            <Route path="guide" element={<PrivateRoute> <Guide /> </PrivateRoute>} />
            <Route path="new_estimation" element={<PrivateRoute> <Simulation /> </PrivateRoute>} />
            <Route path="modify_order" element={<PrivateRoute> <ModifyOrder /> </PrivateRoute>} />
          </Route>
          <Route path="new_analysis" element={<PrivateRoute> <FormNewAnalysis /> </PrivateRoute>} />
          <Route path='*' element={<PageNotFound />} />
          <Route path='error' element={<ServerError />} />
          <Route path='forbidden' element={<Forbidden />} />
          <Route path="payment-success" element={<PaymentSuccess />} />
          <Route path="payment-error" element={<PaymentError />} />
          <Route path="payment" element={<Payment />} />
        </Routes>
      </BrowserRouter>
      <div className="absolute flex justify-center items-center w-full h-full bg-light-gray/50 z-50" style={{ display: "none" }} id="loading">
        <img className="size-28 bg-white rounded-full border border-dark-green shadow-sym" alt="logo" src="/iconslimsvet/loading.gif">
        </img>
      </div>
    </div>
  );
}



